import { NumberValueAccessor } from "@angular/forms/src/directives";

export class  UserProfileDTO {

    UserName : string ;

    Password : string ;

    ConfirmPassword : string ;

    UserId : number ;

    FirstName : string ;

    LastName : string ;

    Email : string ;

    Timezone : string ;

    TimeZoneId : number ;

    TemperatureUnits : string ;

    CompanyId : number ;

    IsFirstTimeUser : boolean ;

    MobileNumber : string ;

    Roles : Array<string> ;

    OrganizationTitle : string ;

    CountryCode : string ;

    CompanyName:string;

    AlertScheduling:SchedulingDTO;
}


export class SchedulingDTO{

    FromTime:number;
    ToTime:number;
    ActiveDays:number;
}

export class ProceduresDTO{

    SpecialityName:string;
    SpecialityId:number;
    ProcedureId:string;
    ProcedureName:string;
    OperationRoomCheckList : CheckListDTO;
    PatientPositionChecklist : CheckListDTO;
    NotesCheckList : CheckListDTO;
    PreperationChecklist : CheckListDTO;
}

export class EquipmentDTO{
    EquipmentId:number;
    selectedStatus:boolean;
    EquipmentName:string;
    Quantity:number;
    Specification:string;
}

export class CategoryDTO{
    CategoryId:number;
    CategoryName:string;
    Equipments:EquipmentDTO[];
}

export class CheckListDTO{
    Images: ImageDTO[];
    Steps:StepDTO[];
}

export class ImageDTO{
    ImageName:string;
    ImageUrl:string;
}

export class StepDTO{
   stepNo:number;
   stepContent:string;
}





// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/company-user/userProfileDTO.model.ts